import React from 'react';
import PropTypes from 'prop-types';
import { getAdsConfig } from '@gameday/utils/selectors/getAdsConfig'
import { useSelector } from 'react-redux';
import SingleAd from '../components/SingleAd';
import { getIsPremiumUser } from '@gameday/utils/selectors/getIsPremiumUser';

const premiumUserFriendlyAds = new Set(['midInning']);

const SingleAdDataContainer = ({
    type,
    className
}) => {
    const { isPremiumUser } = useSelector(getIsPremiumUser);
    const { adsConfig = {} } = useSelector(getAdsConfig);
    const { units } = adsConfig;
    const ad = units?.[type];

    const ads = (typeof ad !== 'undefined') ? (Array.isArray(ad) ? ad : [ad] ): undefined;

    if (isPremiumUser && !premiumUserFriendlyAds.has(type)) {
        return null;
    }

    return <SingleAd ads={ads} type={type} className={className}/>;
};

SingleAdDataContainer.propTypes = {
    type: PropTypes.string,
    className: PropTypes.string
};

export default SingleAdDataContainer;